<template>
  <BackgroundImageLayout v-if="layout === 'bgImage'" />
  <MerchantIntroLayout v-if="layout === 'merchantIntro'" />
  <ResponsiveBackgroundImageLayout v-if="layout === 'responsiveBgImage'" />
</template>

<script setup lang="ts">
  import type { RouteMeta } from "vue-router"
  import { defineAsyncComponent } from "vue"

  type Props = {
    layout?: RouteMeta["layout"]
  }

  defineProps<Props>()

  const ResponsiveBackgroundImageLayout = defineAsyncComponent(
    () => import("@/components/layout/ResponsiveBackgroundImageLayout.vue")
  )

  const BackgroundImageLayout = defineAsyncComponent(
    () => import("@/components/layout/BackgroundImageLayout.vue")
  )

  const MerchantIntroLayout = defineAsyncComponent(
    () => import("@/components/layout/MerchantIntroLayout.vue")
  )
</script>
